/**
 * L'adresse de la fenêtre du planning, et rien d'autre.
 *
 * Séparé du composant pour la même raison que `cibles.ts` l'est de `PlanningRessources` : les
 * **deux bouts** s'en servent — le bouton qui ouvre la fenêtre, dans l'application, et la
 * fenêtre elle-même, qui relit ce que l'adresse lui demande. Une adresse construite d'un côté
 * et décodée de l'autre, chacun avec son propre code, finit toujours par diverger d'un
 * paramètre. Et un module sans React se teste sans navigateur.
 */

/**
 * Le chemin de la fenêtre. Reconnu par `App` avant tout affichage d'écran.
 *
 * Distinct de `/planning-ressources`, qui est l'autre fenêtre satellite (le plan de charge par
 * ressource). Les deux peuvent être ouvertes en même temps et ne regardent pas la même chose :
 * celle-ci montre le planning **d'une contre-étude**, celle-là le chargement des ressources du
 * groupe.
 */
export const CHEMIN_FENETRE_PLANNING = "/planning-chantier";

/**
 * Le nom de la fenêtre du navigateur.
 *
 * **Un nom par version**, contrairement au planning des ressources qui en a un par vue. Chris
 * consulte une contre-étude en regardant son planning : ouvrir une deuxième affaire doit donner
 * une deuxième fenêtre, sinon la première disparaît sous la seconde alors qu'on la regardait.
 * À version égale, le nom est fixe : recliquer ramène la fenêtre déjà ouverte au lieu d'en
 * empiler une troisième.
 */
export function nomFenetrePlanning(versionId: string): string {
  return `planif-planning-${versionId}`;
}

/** L'adresse à ouvrir depuis la contre-étude. */
export function adresseDuPlanningChantier(versionId: string): string {
  const parametres = new URLSearchParams({ version: versionId });
  return `${CHEMIN_FENETRE_PLANNING}?${parametres.toString()}`;
}

/**
 * Ce que l'adresse demande : la version à afficher.
 *
 * Rend `""` quand elle ne dit rien — la fenêtre affiche alors ce qui manque plutôt qu'un écran
 * vide. Une fenêtre ouverte à la main sur le chemin nu est le cas où l'on a le plus besoin
 * d'être renseigné.
 */
export function versionDeLAdresse(recherche: string): string {
  return new URLSearchParams(recherche).get("version") ?? "";
}
